import { TeContainer, TeContainerSlim, TeIcon, TeSpacing, TeText } from '@topcon/tuicl-react';
import { styled } from 'styled-components';
import { IconName } from '@topcon/tuicl/dist/components/icon/icon.utils';
import { Link, LinkProps } from 'react-router-dom';

interface Props {
  icon: IconName;
  title: string;
  description: string;
  buttonText: string;
  route: LinkProps;
  iconOutline?: boolean;
  buttonIcon?: IconName;
}

const Card = ({ icon, title, description, buttonText, route, iconOutline, buttonIcon }: Props) => {
  return (
    <Wrapper>
      <TeContainer
        column
        backgroundColor="background.secondary"
        borderRadius={4}
        grow
        justifyContent="space-between"
      >
        <TeContainerSlim gap="xs" column>
          <TeContainerSlim height={80} width={80} justifyContent="center" alignItems="center">
            <CustomIcon name={icon} size="xl" outline={iconOutline} />
          </TeContainerSlim>
          <TeSpacing direction="y" size="80" />
          <TeText size={16} weight={700}>
            {title}
          </TeText>
          <TeText color="text.secondary">{description}</TeText>
        </TeContainerSlim>
        <TeContainerSlim padding={['xs', 0]}>
          <StyledLink {...route}>
            <TeContainerSlim gap="4xs" alignItems="center" justifyContent="center">
              <TeText size={12} weight={500} color="text.brand.primary">
                {buttonText}
              </TeText>
              {buttonIcon ? <TeIcon name={buttonIcon} size="m" color="text.brand.primary" /> : null}
            </TeContainerSlim>
          </StyledLink>
        </TeContainerSlim>
      </TeContainer>
    </Wrapper>
  );
};

export default Card;

// TODO: Fix this hack
const CustomIcon = styled(TeIcon)`
  transform: scale(2.5);
`;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: 320px;
  display: flex;
`;

const StyledLink = styled(Link)`
  text-decoration: none;
`;
